import templateUrl from './list-divisions-container.component.html'

export const ListDivisionsContainerComponent = {
    controller: ListDivisionsContainerController,
    controllerAs: "vm",
    templateUrl
};

function ListDivisionsContainerController($uibModal, $q, divisionService, utilityService) {
    'ngInject'
    const vm = this;

    let defaultFilter;

    vm.divisions;
    vm.filters;
    vm.onChangeFilters = onChangeFilters;
    vm.onDelete = onDelete;
    vm.divisions = [];
    vm.sortDirection = 1; // Ascending.
    vm.sortField = "Id";
    vm.$onInit = onInit;

    function onInit() {

        const filtersRestored = restoreFilters();
        const divisionsLoaded = loadDivisions();

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError($q.all([filtersRestored, divisionsLoaded]), "Initial load failed"));
    }

    const changeFilters = utilityService.debounce(function () {

        saveFilters();

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(loadDivisions(), "Filtering failed"));
    }, 500);

    function onChangeFilters() {
        changeFilters();
    }

    function saveFilters() {
        localStorage.setItem("listDivisionsFilters", JSON.stringify(vm.filters || {}));
    }


    function loadDivisions() {
        if (!vm.filters) {
            return divisionService.retrieveDivisions()
                .then(function (divisions) {
                    vm.divisions = divisions
                    utilityService.hideLoading();
                });
        } else {
            return divisionService.retrieveDivisions({
                DivisionId: vm.filters.Id,
                Name: vm.filters.Name,
                DefaultRotationLengthTypeName: vm.filters.DefaultRotationLengthTypeName,
                DefaultRotationLength: vm.filters.DefaultRotationLength
            })
                .then(function (divisions) {
                    vm.divisions = divisions
                    utilityService.hideLoading();
                });
        }
    }

    function onDelete(division) {
        confirmDialog('Are you sure you want to delete this division?', division);
    }


    function confirmDialog(message, division) {
        $uibModal.open({
            template:
                '<div class="modal-body">'
                + message
                + '</div>'
                + '<div class="modal-footer">'
                + '<button class="btn btn-plain float-right" ng-click="vm.close()">No</button>'
                + '<button class="btn btn-plain float-right" ng-click="vm.deleteDivision();">Yes</button>'
                + '</div>',

            controller: function ($uibModalInstance) {
                'ngInject';
                this.deleteDivision = function () {
                    utilityService.showLoadingUntilResolved(utilityService.alertOnError(
                        divisionService.deleteDivision(division.Id)
                            .then(function () {
                                $uibModalInstance.close();
                            }),
                        "Deleting failed"
                    ));
                };
                this.close = function () {
                    $uibModalInstance.dismiss();
                };
            },
            controllerAs: "vm",
            showCancelButton: true,
            windowClass: 'xx-dialog pagespinner',
            backdrop: 'static'
        }).result.then(function () {
            vm.divisions = vm.divisions.filter(function (d) {
                return d.Id !== division.Id;
            });
        });
    }

    function restoreFilters() {
        // Restore filters to the grid from localStorage, if available.
        vm.filters = JSON.parse(localStorage.getItem("listDivisionsFilters")) || defaultFilter;

        return $q.when();
    }
}
